// extracted by mini-css-extract-plugin
module.exports = {"container":"GCardPage_container_3Vdt5"};